type Input = {
    threeDsEnabled: boolean
    /** Server-computed on the saved flow. Undefined while unknown (create page, query loading). */
    hasStandalone3dsCapableProcessor: boolean | undefined
}

/**
 * Whether the payment-flow form must warn that the "Standalone 3DS" toggle is a no-op: it is on,
 * and the server says no processor the flow routes to can perform standalone 3DS. While the
 * capability is unknown there is nothing to warn about yet. #TAG-2488
 */
export const shouldWarnStandalone3dsUnsupported = ({
    threeDsEnabled,
    hasStandalone3dsCapableProcessor,
}: Input): boolean => threeDsEnabled && hasStandalone3dsCapableProcessor === false
